import { render } from "./generateLicensedPdf.vue?vue&type=template&id=95a12c06&scoped=true"
import script from "./generateLicensedPdf.vue?vue&type=script&lang=js"
export * from "./generateLicensedPdf.vue?vue&type=script&lang=js"

import "./generateLicensedPdf.vue?vue&type=style&index=0&id=95a12c06&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a12c06"]])

export default __exports__